import React from 'react';
import { Button } from './Button';
export function Header() {
  return <header className="sticky top-0 z-50 bg-[rgba(251,250,247,0.86)] backdrop-blur-[10px] backdrop-saturate-[140%] border-b border-hair" data-id="element-38">
      <div className="max-w-page mx-auto px-6 grid grid-cols-[1fr_auto_1fr] items-center gap-4 py-4" data-id="element-39">
        <nav className="flex gap-7 text-[0.86rem] font-medium" aria-label="Primary" data-id="element-40">
          <a href="https://www.wearchime.com/products/chime" target="_blank" rel="noopener noreferrer" className="no-underline text-ink-60 transition-colors duration-200 hover:text-ink focus-visible:text-ink" data-id="element-41">
            The Chime
          </a>
          <a href="https://www.fermatawellbeing.com" target="_blank" rel="noopener noreferrer" className="no-underline text-ink-60 transition-colors duration-200 hover:text-ink focus-visible:text-ink" data-id="element-42">
            About
          </a>
          <a href="https://www.wearchime.com/pages/contact" target="_blank" rel="noopener noreferrer" className="no-underline text-ink-60 transition-colors duration-200 hover:text-ink focus-visible:text-ink" data-id="element-43">
            Contact
          </a>
        </nav>

        <div className="justify-self-center text-center leading-none" data-id="element-44">
          <span className="font-display font-semibold text-[1.32rem] tracking-[-0.01em] block" data-id="element-45">
            Fermata Wellbeing
          </span>
          <span className="block text-[0.56rem] tracking-[0.34em] uppercase text-ink-40 mt-1" data-id="element-46">
            Evidence-based living
          </span>
        </div>

        <div className="justify-self-end hidden md:block" data-id="element-47">
          <Button href="https://www.wearchime.com/products/chime" size="sm" data-id="element-48">
            Choose your Chime
          </Button>
        </div>
      </div>
    </header>;
}